import React from 'react';
import Grade10to9 from './Grades/Grade_Gup_10to9';
import './Gradings.css';

function Gradings() {
    return (
        <div className='sectionPage gradings-page'>
            <Grade10to9 />
        </div>
    );
}

export default Gradings;